export const MAX_NUMBER_OF_CARDS = 42;

// Console warnings
export const ERROR_TA_INVALID_ECOMMERCE_PRODUCTS_LINK = 'TAErrorInvalidEcommerceProductsLink';
export const ERROR_TA_MISSING_TRACKING_ATTRIBUTES = 'TAErrorMissingTrackingAttributes';
// cookie keys
export const AGE_CONFIRMED = 'age_confirmed';
